import { PromoCodeType, useGetNewUserPromoCodeQuery } from 'src/gqlReactTypings.generated.d';
import { usePromotionalsHook } from 'src/promotionals/usePromotionalsHook';
import { match } from 'ts-pattern';

export const useGetSignupPromo = () => {
  const { data, loading } = useGetNewUserPromoCodeQuery();
  const { code: currentPromoCode } = usePromotionalsHook();

  return match(currentPromoCode)
    .with({ promoCodeType: PromoCodeType.Referral }, { isShefToConsumerPromo: true }, () => ({
      signupPromo: currentPromoCode,
      loading: false,
    }))
    .otherwise(() => ({ signupPromo: data?.newUserPromoCode, loading }));
};
